// import React, { createContext, useContext, useEffect, useState } from "react";
// import useStyles from "./styles";
// import { styled, Tab, Tabs, Box, Stack } from "@mui/material";
// import Summary from "./components/Summary";
// import { useNavigate, useParams } from "react-router-dom";
// import Inclusions from "./components/Inclusions";
// import PackageImages from "./components/PackageImages";
// import Review from "./components/Review";
// import PackageGroups from "./components/PackageGroups";

// const PackageContext = createContext();

// const StyledTabs = styled(Tabs)({
//   display: "flex",
//   gap: "10px",
//   padding: "0",
// });

// const StyledTab = styled(Tab)(({ selected }) => ({
//   display: "flex",
//   alignItems: "center",
//   gap: "8px",
//   padding: "1vh 1vw",
//   borderRadius: "60px",
//   fontFamily: "Inter Tight",
//   fontWeight: 600,
//   textTransform: "none",
//   backgroundColor: selected ? "#0D0D0D" : "#F7F7F7",
//   color: selected ? "#FFFFFF !important" : "#949DAA !important",
//   transition: "all 0.3s ease-in-out",
//   "&:hover": {
//     backgroundColor: selected ? "#0D0D0D" : "#EDEDED",
//     color: selected ? "#FFFFFF" : "#000",
//   },
//   marginRight: "10px",
// }));

// const TabNumber = styled("span")(({ selected }) => ({
//   width: "28px",
//   height: "32px",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   borderRadius: "60px",
//   fontSize: "14px",
//   fontWeight: 600,
//   padding: "1vh 1vw",
//   backgroundColor: selected ? "#3d3d3d" : "#FFFFFF",
//   color: selected ? "#9e9e9e" : "#949DAA",
//   border: "none !important",
// }));
// const tabRoutes = ["", "inclusion", "groups", "images", "review"];

// function NewCreatePackage() {
//   const { id, tab } = useParams();
//   const [packageDetails, setPackageDetails] = useState({});
//   const [isGroupLocal, setIsGroupLocal] = useState(false);
//   const navigate = useNavigate();
//   const classes = useStyles();

//   useEffect(() => {
//     if (id) {
//       setPackageDetails({ id: id });
//     }
//   }, [id]);

//   // Sync isGroupLocal with packageDetails.isGroup when packageDetails is loaded
//   useEffect(() => {
//     if (packageDetails?.isGroup !== undefined) {
//       setIsGroupLocal(packageDetails.isGroup);
//     }
//   }, [packageDetails?.isGroup]);

//   useEffect(() => {
//     console.log("pac", packageDetails);
//   }, [packageDetails]);

//   useEffect(() => {
//     if (tab && !tabRoutes.includes(tab)) {
//       navigate(`/new-create-package/${id || ""}/${tabRoutes[0]}`, {
//         replace: true,
//       });
//     }
//   }, [id, tab, navigate]);

//   const tabValue = tabRoutes.indexOf(tab || "");

//   const handleTabChange = (event, newValue) => {
//     const newTabRoute = tabRoutes[newValue]
//       ? `/new-create-package/${id || ""}/${tabRoutes[newValue]}`
//       : `/new-create-package/${id || ""}`;
//     navigate(newTabRoute);
//   };

//   const modalStyle = {
//     display: "flex",
//     flexDirection: "column",
//     gap: "16px",
//     bgcolor: "background.paper",
//     padding: "0 !important",
//     overflow: "hidden",
//     margin: "20px 0",
//     height: "100%",
//   };

//   const renderSwitch = () => {
//     switch (tabValue) {
//       case 0:
//         return <Summary />;
//       case 1:
//         return <Inclusions />;
//       case 2:
//         return <PackageGroups />;
//       case 3:
//         return <PackageImages />;
//       case 4:
//         return <Review />;
//     }
//   };

//   return (
//     <PackageContext.Provider value={{ packageDetails, setPackageDetails, isGroupLocal, setIsGroupLocal }}>
//       <div
//         className={classes.container}
//         style={{
//           padding: "3vh 3vw 2vh 3vw",
//           display: "flex",
//           flexDirection: "column",
//           flex: 1,
//           backgroundColor: "#fff",
//         }}
//       >
//         <Box sx={modalStyle}>
//           <Stack direction="row" justifyContent="space-between">
//             <StyledTabs
//               value={tabValue}
//               variant="scrollable"
//               onChange={handleTabChange}
//               aria-label="Styled Tabs"
//               sx={{
//                 "& .MuiTabs-indicator": {
//                   background: "none",
//                 },
//               }}
//             >
//               {tabRoutes.map((route, index) => {
//                 if (index === 2 && !isGroupLocal) {
//                   return null;
//                 }

//                 // Calculate the adjusted tab number based on visibility
//                 let adjustedTabNumber;
//                 if (index === 2 && isGroupLocal) {
//                   // Groups tab is visible, so it gets 03
//                   adjustedTabNumber = 3;
//                 } else if (index > 2 && !isGroupLocal) {
//                   // Groups tab is hidden, so subsequent tabs get shifted down by 1
//                   adjustedTabNumber = index;
//                 } else {
//                   // Normal numbering for other tabs
//                   adjustedTabNumber = index + 1;
//                 }

//                 return (
//                   <StyledTab
//                     key={index}
//                     label={
//                       <Box display="flex" alignItems="center" gap={1}>
//                         <TabNumber selected={tabValue === index}>{`0${adjustedTabNumber}`}</TabNumber>
//                         <span>
//                           {route
//                             ? route
//                               .replace("-", " ")
//                               .replace(/\b\w/g, (char) => char.toUpperCase())
//                             : "Summary"}
//                         </span>
//                       </Box>
//                     }
//                     disabled={
//                       (index === 1 &&
//                         (!packageDetails ||
//                           Object?.keys(packageDetails)?.length === 0)) ||
//                       (index === 3 && !packageDetails?.inclusions) ||
//                       (index === 4 && !packageDetails?.inclusions) ||
//                       !packageDetails?.images
//                     }
//                     sx={{
//                       cursor:
//                         (index === 1 &&
//                           (!packageDetails ||
//                             Object?.keys(packageDetails)?.length === 0)) ||
//                           (index === 3 && !packageDetails?.inclusions) ||
//                           (index === 4 && !packageDetails?.inclusions) ||
//                           !packageDetails?.images
//                           ? "not-allowed"
//                           : "pointer",
//                     }}
//                   />
//                 );
//               })}
//             </StyledTabs>
//           </Stack>
//           {renderSwitch()}
//         </Box>
//       </div>
//     </PackageContext.Provider>
//   );
// }
// export default NewCreatePackage;

// export const usePackageContext = () => useContext(PackageContext);

import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import useStyles from "./styles";
import { styled, Tab, Tabs, Box, Stack } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import Summary from "./components/Summary";
import Inclusions from "./components/Inclusions";
import PackageImages from "./components/PackageImages";
import Review from "./components/Review";
import PackageGroups from "./components/PackageGroups";

const PackageContext = createContext();

const StyledTabs = styled(Tabs)({
  display: "flex",
  gap: "10px",
  padding: "0",
});

const StyledTab = styled(Tab)(({ selected }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  padding: "1vh 1vw",
  borderRadius: "60px",
  fontFamily: "Inter Tight",
  fontWeight: 600,
  textTransform: "none",
  backgroundColor: selected ? "#0D0D0D" : "#F7F7F7",
  color: selected ? "#FFFFFF !important" : "#949DAA !important",
  transition: "all 0.3s ease-in-out",
  "&:hover": {
    backgroundColor: selected ? "#0D0D0D" : "#EDEDED",
    color: selected ? "#FFFFFF" : "#000",
  },
  marginRight: "10px",
}));

const TabNumber = styled("span")(({ selected }) => ({
  width: "28px",
  height: "32px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "60px",
  fontSize: "14px",
  fontWeight: 600,
  padding: "1vh 1vw",
  backgroundColor: selected ? "#3d3d3d" : "#FFFFFF",
  color: selected ? "#9e9e9e" : "#949DAA",
  border: "none !important",
}));

function NewCreatePackage() {
  const { id, tab } = useParams();
  const [packageDetails, setPackageDetails] = useState({});
  const [isGroupLocal, setIsGroupLocal] = useState(false);
  const navigate = useNavigate();
  const classes = useStyles();

  const tabRoutes = useMemo(() => {
    return isGroupLocal
      ? ["", "inclusion", "groups", "images", "review"]
      : ["", "inclusion", "images", "review"];
  }, [isGroupLocal]);

  const tabValue = tabRoutes.indexOf(tab || "");

  useEffect(() => {
    if (id) {
      setPackageDetails({ id: id });
    }
  }, [id]);

  useEffect(() => {
    if (packageDetails?.isGroup !== undefined) {
      setIsGroupLocal(packageDetails.isGroup);
    }
  }, [packageDetails?.isGroup]);

  useEffect(() => {
    if (tab && !tabRoutes.includes(tab)) {
      navigate(`/new-create-package/${id || ""}/${tabRoutes[0]}`, {
        replace: true,
      });
    }
  }, [id, tab, tabRoutes, navigate]);

  const handleTabChange = (event, newValue) => {
    const newTabRoute = tabRoutes[newValue]
      ? `/new-create-package/${id || ""}/${tabRoutes[newValue]}`
      : `/new-create-package/${id || ""}`;
    navigate(newTabRoute);
  };

  const modalStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    bgcolor: "background.paper",
    padding: "0 !important",
    overflow: "hidden",
    margin: "20px 0",
    height: "100%",
  };

  const renderSwitch = () => {
    switch (tabRoutes[tabValue]) {
      case "":
        return <Summary />;
      case "inclusion":
        return <Inclusions />;
      case "groups":
        return <PackageGroups />;
      case "images":
        return <PackageImages />;
      case "review":
        return <Review />;
      default:
        return null;
    }
  };

  return (
    <PackageContext.Provider
      value={{
        packageDetails,
        setPackageDetails,
        isGroupLocal,
        setIsGroupLocal,
      }}
    >
      <div
        className={classes.container}
        style={{
          padding: "3vh 3vw 2vh 3vw",
          display: "flex",
          flexDirection: "column",
          flex: 1,
          backgroundColor: "#fff",
        }}
      >
        <Box sx={modalStyle}>
          <Stack direction="row" justifyContent="space-between">
            <StyledTabs
              value={tabValue}
              variant="scrollable"
              onChange={handleTabChange}
              aria-label="Styled Tabs"
              sx={{
                "& .MuiTabs-indicator": {
                  background: "none",
                },
              }}
            >
              {tabRoutes.map((route, index) => {
                const label = route
                  ? route
                      .replace("-", " ")
                      .replace(/\b\w/g, (char) => char.toUpperCase())
                  : "Summary";

                return (
                  <StyledTab
                    key={index}
                    label={
                      <Box display="flex" alignItems="center" gap={1}>
                        <TabNumber selected={tabValue === index}>{`0${
                          index + 1
                        }`}</TabNumber>
                        <span>{label}</span>
                      </Box>
                    }
                    disabled={
                      (route === "inclusion" &&
                        (!packageDetails ||
                          Object?.keys(packageDetails)?.length === 0)) ||
                      (route === "images" && !packageDetails?.inclusions) ||
                      (route === "review" && !packageDetails?.inclusions) ||
                      !packageDetails?.images
                    }
                    sx={{
                      cursor:
                        (route === "inclusion" &&
                          (!packageDetails ||
                            Object?.keys(packageDetails)?.length === 0)) ||
                        (route === "images" && !packageDetails?.inclusions) ||
                        (route === "review" && !packageDetails?.inclusions) ||
                        !packageDetails?.images
                          ? "not-allowed"
                          : "pointer",
                    }}
                  />
                );
              })}
            </StyledTabs>
          </Stack>
          {renderSwitch()}
        </Box>
      </div>
    </PackageContext.Provider>
  );
}

export default NewCreatePackage;

export const usePackageContext = () => useContext(PackageContext);
